//Uppercase.js
export function Uppercase(str) {
    if (str === null || str === undefined) {
        return '';
    }

    if (str === '') {
        return str;
    }

    return str?.charAt(0).toUpperCase() + str.slice(1);
}